import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "./Index.css";

const DMS = () => {
  const images = [
    require("../../assets/img/dms1.png"),
    require("../../assets/img/dms1.png"),
    require("../../assets/img/dms1.png"),
  ];

  return (
    <div className="py-12 pt-0 ">
      {/* Header Section */}
      <div className="bg-[#F1F3F4] pt-20 flex justify-between items-center px-20 py-4 shadow-sm">
        {/* Left Text */}
        <span className="text-gray-700 font-bold uppercase text-sm">
          Dealer Management System
        </span>

        {/* Right Button */}
        <button className="text-blue-600 font-semibold text-sm hover:underline">
          Request Demo &gt;
        </button>
      </div>
      <div className="bg-gradient-to-b from-white to-blue-50 py-12 px-12 pt-0 background-gradient background-gradient-2">
        {/* Hero Section */}
        <section className="px-4 sm:px-8 lg:px-12 py-12 mt-4 max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-2 items-center">
            {/* Text Content */}
            <div className="w-full max-w-lg">
              <h2 className="text-4xl font-semibold text-gray-800 opacity-80 mb-4">
                The DMS Is the Engine That Drives Your Operation
              </h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                The ready-to-deploy DMS is a complete solution for OEMs,
                distributors, and dealers, offering primary sales data
                management to streamline operations and enhance efficiency.
              </p>
              <button className="bg-gradient-to-b from-[#0D89C8] to-[#34CBB7] text-white px-6 sm:px-8 py-3 rounded-lg hover:bg-blue-600 focus:outline-none">
                Book a demo call
              </button>
            </div>

            {/* Swiper Carousel */}
            <div className="relative min-w-[110%] min-h-[100%] max-w-full">
              <Swiper
                modules={[Navigation, Autoplay]}
                navigation
                autoplay={{ delay: 3000 }}
                loop={true}
                className="w-full custom-swiper"
              >
                {images.map((image, index) => (
                  <SwiperSlide key={index}>
                    <img
                      src={image}
                      alt={`Carousel Image ${index + 1}`}
                      className="rounded-lg w-full object-cover"
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </section>

        {/* Cloud-Based DMS Section */}
        <section className="px-4 sm:px-8 lg:px-12 py-12 max-w-full">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            {/* Image with Labels */}
            <div className="relative bg-gray-100 p-6 max-w-full rounded-lg mx-auto">
              <img
                src={require("../../assets/img/DMSimage.png")}
                alt="Web and App"
                className="w-full max-w-full object-cover"
              />
              <div className="absolute top-4 right-4 bg-white text-gray-700 text-xs sm:text-sm font-semibold px-2 sm:px-4 py-1 sm:py-2 rounded-lg shadow-md">
                Web Based
              </div>
              {/* Adjusted position for Dealer App label */}
              <div className="absolute bottom-6 left-6 bg-white text-gray-700 text-xs sm:text-sm font-semibold px-2 sm:px-4 py-1 sm:py-2 rounded-lg shadow-md">
                Dealer App
              </div>
            </div>

            {/* Text Content */}
            <div className="w-full max-w-lg">
              <h2 className="text-4xl font-semibold text-gray-800 opacity-80 mb-4">
                Ready To Deploy Cloud Based DMS
              </h2>
              <p className="text-gray-700 leading-relaxed mb-6">
                The ready-to-deploy DMS is a complete solution for OEMs,
                distributors, and dealers, offering primary sales data
                management to streamline operations and enhance efficiency.The
                ready-to-deploy DMS is a complete solution for OEMs,
                distributors, and dealers, offering primary sales data
                management to streamline operations and enhance efficiency.
              </p>
            </div>
          </div>
        </section>

        {/* Custom CSS */}
        <style jsx>{`
          .swiper-button-prev,
          .swiper-button-next {
            font-size: 16px; /* Smaller arrow size */
            width: 40px; /* Adjust arrow container width */
            height: 40px; /* Adjust arrow container height */
            color: rgba(
              0,
              0,
              0,
              0.5
            ); /* Optional background for better visibility */
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .swiper-button-prev::after,
          .swiper-button-next::after {
            font-size: 16px; /* Smaller inner arrow icon size */
          }

          .swiper-slide {
            background: transparent !important; /* Override default background */
          }

          .swiper {
            background: transparent !important; /* Remove any container background */
          }
        `}</style>
      </div>
    </div>
  );
};

export default DMS;
